{
  "es": {
    "marketplace_partner": {
      "contact_me": {
        "button": "¡Contáctame!",
        "failure": "Se ha producido un error inesperado.",
        "success": "Nos pondremos en contacto contigo en breve."
      }
    }
  }
}
